export const ANIMATION_SPEED = {
  INIT: 0.4,
  TRANSITION: 1.2,
  SCROLL: 0.000015,
};

export const CAMERA_CONFIG = {
  fov: 60,
  position: [0, 0, 10] as [number, number, number],
} as const;

export const VIEWPORT = {
  BREAKPOINTS: {
    MOBILE: 768,
    TABLET: 1024,
  },
  IMAGE_SCALE: {
    MOBILE: 0.2, // 60% de la taille originale
    TABLET: 0.2, // 40% de la taille originale
    DESKTOP: 0.13, // 25% de la taille originale
  },
  SPACINGS: {
    MOBILE: 50,
    TABLET: 50,
    DESKTOP: 50,
  },
} as const;
